(function(){
'use strict';
if(window.__BGC_DRAWER_UTILITY_ACTIONS_2026__)return;
window.__BGC_DRAWER_UTILITY_ACTIONS_2026__=1;

var CONFIRM_MS=4500;
var confirmUntil=0;
var resetTimer=null;
var mountTimer=null;

function q(sel,root){return (root||document).querySelector(sel);}
function qa(sel,root){return Array.prototype.slice.call((root||document).querySelectorAll(sel));}
function cartRoot(){return document.getElementById('cart');}

function installStyles(){
  if(document.getElementById('bgc-drawer-utility-actions-css'))return;
  var style=document.createElement('style');
  style.id='bgc-drawer-utility-actions-css';
  style.textContent=[
    '#cart .bgc-drawer-utility-actions{list-style:none!important;display:grid!important;grid-template-columns:1fr 1fr!important;gap:7px!important;width:calc(100% - 24px)!important;margin:8px 12px 12px!important;padding:0!important;border:0!important;background:transparent!important;position:relative!important;z-index:20!important}',
    '#cart .bgc-drawer-utility-actions:after{display:none!important}',
    '#cart .bgc-drawer-utility-actions button,#cart .bgc-drawer-utility-actions a{display:flex!important;align-items:center!important;justify-content:center!important;box-sizing:border-box!important;min-width:0!important;min-height:38px!important;margin:0!important;padding:8px 7px!important;border-radius:8px!important;font-size:10px!important;line-height:1.1!important;font-weight:800!important;text-align:center!important;text-decoration:none!important;white-space:normal!important;cursor:pointer!important;letter-spacing:.02em!important}',
    '#cart .bgc-drawer-clear-cart{background:#fff!important;color:#9f342d!important;border:1px solid #9f342d!important}',
    '#cart .bgc-drawer-clear-cart.is-confirming{background:#9f342d!important;color:#fff!important;border-color:#9f342d!important}',
    '#cart .bgc-drawer-clear-cart:disabled{opacity:.6!important;cursor:wait!important}',
    '#cart .bgc-drawer-larger-cart{background:#d99b32!important;color:#fff!important;border:1px solid #c78927!important}',
    '#cart .bgc-drawer-larger-cart:hover,#cart .bgc-drawer-larger-cart:focus{color:#fff!important}'
  ].join('');
  document.head.appendChild(style);
}

function buildBar(){
  var bar=document.createElement('li');
  bar.className='bgc-drawer-utility-actions';
  bar.setAttribute('role','group');
  bar.setAttribute('aria-label','Cart actions');
  bar.innerHTML='<button type="button" class="bgc-drawer-clear-cart">CLEAR CART</button><a href="/cart" class="bgc-drawer-larger-cart">LARGER CART VIEW</a>';
  return bar;
}

function mount(){
  installStyles();
  var root=cartRoot();
  if(!root)return;
  var subtitle=q('li.mm-subtitle',root);
  var list=subtitle&&subtitle.parentElement&&subtitle.parentElement.tagName==='UL'?subtitle.parentElement:null;
  if(!list)list=q('.mm-panel ul, .mm-listview, ul',root);
  if(!list)return;

  var bars=qa('.bgc-drawer-utility-actions',root);
  var bar=bars.shift()||null;
  bars.forEach(function(node){node.remove();});
  if(!bar)bar=buildBar();

  if(subtitle&&subtitle.parentElement===list){
    if(subtitle.nextElementSibling!==bar)subtitle.insertAdjacentElement('afterend',bar);
  }else if(bar.parentElement!==list||list.firstElementChild!==bar){
    list.insertBefore(bar,list.firstChild);
  }
}

window.__BGC_DRAWER_UTILITY_MOUNT_2026__=mount;

function scheduleMount(delay){
  clearTimeout(mountTimer);
  mountTimer=setTimeout(mount,typeof delay==='number'?delay:0);
}

function resetClearButton(button){
  confirmUntil=0;
  if(!button)return;
  button.classList.remove('is-confirming');
  button.disabled=false;
  button.textContent='CLEAR CART';
  button.setAttribute('aria-label','Clear cart');
}

function armClear(button){
  clearTimeout(resetTimer);
  confirmUntil=Date.now()+CONFIRM_MS;
  button.classList.add('is-confirming');
  button.textContent='YES, CLEAR CART';
  button.setAttribute('aria-label','Confirm clear cart');
  resetTimer=setTimeout(function(){
    if(Date.now()>=confirmUntil)resetClearButton(button);
  },CONFIRM_MS+50);
}

function clearCart(button){
  clearTimeout(resetTimer);
  confirmUntil=0;
  button.classList.remove('is-confirming');
  button.disabled=true;
  button.textContent='CLEARING…';

  var rootPath=(window.Shopify&&Shopify.routes&&Shopify.routes.root)?Shopify.routes.root:'/';
  fetch(rootPath+'cart/clear.js',{
    method:'POST',
    credentials:'same-origin',
    cache:'no-store',
    headers:{'Accept':'application/json','Content-Type':'application/json'},
    body:'{}'
  }).then(function(response){
    if(!response.ok)throw new Error('Cart clear failed');
    return response.json();
  }).then(function(cart){
    if(cart&&typeof cart.item_count!=='undefined'&&Number(cart.item_count)!==0)throw new Error('Cart was not emptied');
    window.location.reload();
  }).catch(function(){
    button.disabled=false;
    button.textContent='TRY AGAIN';
    button.setAttribute('aria-label','Clear cart failed. Try again.');
    resetTimer=setTimeout(function(){resetClearButton(button);},1800);
  });
}

document.addEventListener('click',function(event){
  var target=event.target;
  if(!target||!target.closest)return;

  var clear=target.closest('#cart .bgc-drawer-clear-cart');
  if(clear){
    event.preventDefault();
    event.stopPropagation();
    if(clear.disabled)return;
    if(Date.now()<confirmUntil){clearCart(clear);}
    else{armClear(clear);}
  }
},false);

document.addEventListener('shopify:section:load',function(){scheduleMount(40);},false);
window.addEventListener('pageshow',function(){scheduleMount(0);});

if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',mount,{once:true});
else mount();
})();